<script>
import WorkItemDetail from '~/work_items/components/work_item_detail.vue';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import AgentPlan from 'ee/work_items/components/agent_plan/agent_plan.vue';
import WorkItemAgentSessions from 'ee/work_items/components/agent_sessions/index.vue';
import { findWidget } from '~/work_items/list/utils';
import { WIDGET_TYPE_AGENT_PLAN } from '../constants';

export default {
  name: 'WorkItemDetailEE',
  components: {
    WorkItemDetail,
    AgentPlan,
    WorkItemAgentSessions,
  },
  mixins: [glFeatureFlagsMixin()],
  inheritAttrs: false,
  methods: {
    isAgentPlanAvailable(workItem) {
      return this.glFeatures.workItemFeaturesField
        ? workItem.features?.agentPlan || false
        : findWidget(WIDGET_TYPE_AGENT_PLAN, workItem);
    },
  },
};
</script>

<template>
  <work-item-detail v-bind="$attrs" v-on="$listeners">
    <template #widgets="{ workItem }">
      <agent-plan
        v-if="workItem && isAgentPlanAvailable(workItem)"
        :work-item="workItem"
        :can-update="workItem.userPermissions?.updateWorkItem"
      />
      <work-item-agent-sessions v-if="workItem" :work-item-id="workItem.id" />
    </template>
  </work-item-detail>
</template>
